import { DrawerMenuItemList } from 'Components/Layout/DrawerMenu/DrawerMenuItemList'
import type { NavLinkItem } from 'Components/Layout/DrawerMenu/types'
import { t } from 'ttag'

export default function SchoolDrawerMenuContent() {
  const drawerMenuNavLinks: NavLinkItem[] = [
    {
      title: t`Schools`,
      link: `/school-management/schools`
    },
    {
      title: t`Calendars`,
      link: `/school-management/school-calendars`
    }
  ]

  return <DrawerMenuItemList navLinks={drawerMenuNavLinks} rootUrl="/school-management" />
}
